import { DAGOutput } from '~/types/queenbee/io'

export const isDagOutputArtifact = (output: DAGOutput): boolean => {
  return (output.from as any).path !== undefined
}

export const isArtifact = (io: any): boolean => {
  if (io.type.includes("File") || io.type.includes("Folder") || io.type.includes("Path")) {
    return true
  }
  return false
}